module.exports = __webpack_public_path__ + "img/new-step2.e406b61b.jpg";